import { render, staticRenderFns } from "./ModalObjects.vue?vue&type=template&id=2d0a5e6a&"
import script from "./ModalObjects.vue?vue&type=script&lang=js&"
export * from "./ModalObjects.vue?vue&type=script&lang=js&"
import style0 from "./ModalObjects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports